import { render, staticRenderFns } from "./user-live.vue?vue&type=template&id=1a1b45ac&scoped=true&"
import script from "./user-live.vue?vue&type=script&lang=js&"
export * from "./user-live.vue?vue&type=script&lang=js&"
import style0 from "./user-live.vue?vue&type=style&index=0&id=1a1b45ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a1b45ac",
  null
  
)

export default component.exports